import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Context } from '../shared/services/context.service';
import { Contact } from '../model/Contact.model';
import { ContactDTO } from '../model/ContactDTO';
import { TypePers } from '../model/TypePers';
import { Categorie } from '../model/Categorie';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

    constructor(private http: HttpClient) {}


    getAllContacts(): Observable<ContactDTO[]> {
        return this.http.get<ContactDTO[]>(Context.apiUrl + 'contacts/all');
    }

    getContactsByType(typeId: number): Observable<ContactDTO[]> {
        return this.http.get<ContactDTO[]>(Context.apiUrl + 'contacts/type/' + typeId);
    }

    getContactsByTypeAndPatient(typeId: number, idPersonne: number): Observable<ContactDTO[]> {
        return this.http.get<ContactDTO[]>(Context.apiUrl + 'contacts/type/' + typeId + '/patient/' + idPersonne);
    }

    addContact(contact: ContactDTO): Observable<ContactDTO> {
        return this.http.post<ContactDTO>(Context.apiUrl + 'contacts/add', contact);
    }

    updateContact(contact: ContactDTO): Observable<ContactDTO> {
        return this.http.put<ContactDTO>(Context.apiUrl + 'contacts/update/' + contact.id, contact);
    }

    deleteContact(id: number): Observable<void> {
        return this.http.delete<void>(Context.apiUrl + 'contacts/delete/' + id);
    }

    getAllContactTypes(): Observable<TypePers[]> {
        return this.http.get<TypePers[]>(Context.apiUrl + 'type-pers/all');
    }

    getAllCategories(): Observable<Categorie[]> {
        return this.http.get<Categorie[]>(Context.apiUrl + 'categories');
    }


    getContactByIdPersonne(idPersonne: number): Observable<Contact[]> {
        return this.http.get<Contact[]>(Context.apiUrl + 'get_contact_of/' + idPersonne);
    }

    getContact(idPatient: number): Observable<Contact[]> {
        return this.http.get<Contact[]>(Context.apiUrl + 'Contact/' + idPatient);
    }

    getAllContactMail(): Observable<any[]> {
        return this.http.get<any[]>(Context.apiUrl + 'ContactMail/');
    }

    updateContactLegacy(contacts: Contact[]): Observable<any> {
        return this.http.put<any>(Context.apiUrl + 'updateContact', contacts);
    }

    getContactLib(): Observable<any[]> {
        return this.http.get<any[]>(Context.apiUrl + 'ContactLibs');
    }

    sendNewsLetter(subject: string, body: string, to: any[]): Observable<any> {
        return this.http.put<any>(
            Context.apiUrl + 'newsLetters/?subject=' + subject + '&body=' + body,
            to
        );
    }
}
